import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Port, AdvancedRouteGate, GeoJsonFeatureCollection } from '../models/routing.models';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RoutingService {
  private apiUrl = environment.apiBaseUrl + '/api'; // Adjust based on your environment config

  constructor(private http: HttpClient) { }

  /** Search ports by name substring */
  searchPorts(query: string, limit: number = 10): Observable<{ ports: Port[] }> {
    const params = new HttpParams().set('q', query).set('limit', limit.toString());
    return this.http.get<{ ports: Port[] }>(`${this.apiUrl}/ports/search`, { params });
  }

  /** Find nearest ports to a specific coordinate */
  getNearestPorts(lat: number, lon: number, limit: number = 3): Observable<{ ports: Port[] }> {
    const params = new HttpParams()
      .set('lat', lat.toString())
      .set('lon', lon.toString())
      .set('limit', limit.toString());
    return this.http.get<{ ports: Port[] }>(`${this.apiUrl}/ports/nearest`, { params });
  }

  /** Fetch land-clipped maritime zones (ECA, TSS, etc.) for map rendering */
  getClippedZone(zoneType: string): Observable<GeoJsonFeatureCollection> {
    return this.http.get<GeoJsonFeatureCollection>(`${this.apiUrl}/geojson-clipped/${zoneType}`);
  }

  /** Fetch passage and canal gates */
  getAdvancedRouting(): Observable<AdvancedRouteGate[]> {
    return this.http.get<AdvancedRouteGate[]>(`${this.apiUrl}/advanced-routing`);
  }

  /** Calculate route */
  calculateRoute(data: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/route`, data);
  }

  /** Find nearest land */
  getNearestLand(lat: number, lon: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/nearest-land`, {
      params: new HttpParams().set('lat', lat.toString()).set('lon', lon.toString())
    });
  }

  /** Fetch all ports of a type */
  getAllPorts(type: string): Observable<GeoJsonFeatureCollection> {
    return this.http.get<GeoJsonFeatureCollection>(`${this.apiUrl}/ports/all`);
  }

  /** Fetch golden routes */
  getGoldenRoutes(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/golden-routes`);
  }
}
